// extracted by mini-css-extract-plugin
export default {"desktopRoot":"clientDesktop_desktopRoot__MomdE","desktopMainInner":"clientDesktop_desktopMainInner__J4t3u","desktopWide":"clientDesktop_desktopWide__j6mdV"};